import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const Support: React.FunctionComponent = () => (
  <Svg
    width={287}
    height={270}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M2.518 171.428c5.8-22.2 34.8-60.9 19.9-79.5-36-44.9-20.1-94.9 35.2-89.1 10 1 22.4 4.8 31 11.1 41.4 30.3 95.7-38.3 133.5 7.5 36.7 44.6 2.1 101.8 41.3 113.6 55.3 19.4-.7 136.1-57.8 132.7-55-.5-71.4.5-116.8-1-16.8-1.5-104.7-24.7-86.3-95.3z"
      fill="#E5F3F7"
    />
    <path
      d="M66.018 193.328c-.5 11 .2 58.5.2 63.8 0 5.3.3 10.2 1.1 10.2 1.4 0 3.3-4.6 4.7-15.1 1.4-10.5 5.8-61.1 5.8-61.1m18.6.9c-.7 1.8 3.4 39 4.6 52 1.1 12.9 3.4 23.6 4.9 23.4 1.7-.3 1.7-13.9 1.4-23.2-.2-9.2-.7-53.5-.7-53.5"
      stroke="#3C5749"
      strokeWidth={0.377}
      strokeMiterlimit={10}
    />
    <path
      d="M129.318 239.828l.2 2.1c.3 3 1.4 5.9 3.1 8.4l4.1 6.1 10.8 5.7s4.1 7-.3 7.3c-4.4.3-24.7-9.8-27.4-12.7-2.7-3-.7-9.2-.7-9.2l-.4-7 10.6-.7zm39.1-36.9l13.9 9.8 12.8 1.6s6.6 5.4 2.4 7.3c-4.3 1.9-28-.5-31.8-2.4-3.8-1.9-3.7-9.4-3.7-9.4l-2.9-5.2 9.3-1.7z"
      fill="#C5A58B"
    />
    <path
      d="M88.518 96.328s3.9 37.1 6.4 40.6c2.5 3.5 11.4-3.1 11.4-3.1l-4.8-37.3c.1 0-12-1.6-13-.2z"
      fill="#E3C7B0"
    />
    <path
      d="M83.918 71.328c2.4.8 9.3 2.1 11.5 5.5 2.3 3.4 8.7 25.9 8.4 27.3-.3 1.3-16.9 5.8-17.7 4.3-.8-1.4-2.2-37.1-2.2-37.1z"
      fill="#3C5749"
    />
    <path
      d="M118.518 118.728c-.2.1-2 3-.9 3.7 1 .7 2.4-1.4 2.4-1.4s.6-3.3-1.5-2.3z"
      fill="#E3C7B0"
    />
    <path
      d="M59.218 182.128c-.3 1.2-.9 9.3.1 10.6 1 1.2 54.1 3.9 55.5 1.9 1.5-2.3 2.7-10.6 1.6-11.6-.9-1.1-57.2-.9-57.2-.9z"
      fill="#F15D4B"
    />
    <path
      d="M158.818 207.828c-1.6-1.6-38.8-60.2-37.3-68.6 1.5-8.4 8.7-14.6 9.3-14.9.6-.3 9 3.4 11.2 5.9 2.2 2.5 30.1 73.6 30.4 74.5.4.9-13.6 3.1-13.6 3.1z"
      fill="#F8AF97"
    />
    <path
      d="M74.618 182.728l73 2.5s5.9-16.1 5.3-19.3c-.4-2.2-7.6-9.6-8.1-10.6-.4-.9-15-1.7-30.4-1.6-17.9.2-36.3-.3-36.3-.3l-3.5 29.3z"
      fill="#F79E81"
    />
    <path
      d="M116.618 244.128h14.3c.9 0 15.2-54.7 17.1-60.6 1.9-5.9 4.7-16.1 4.7-17.1 0-.9-6.3-9.8-7.5-10.6-2.2-1.6-23.3 25.8-23 27 .3 1.4-5.6 61.3-5.6 61.3z"
      fill="#F79E81"
    />
    <path
      d="M102.718 132.428s16.9-13.1 18.4-13.2c1.1-.1 6.1 1.3 9 2.1.9.2 1.3 1.6.5 2.4-3.8 4.1-15.2 14.6-15.6 14.8-.5.2-13-4.3-13.2-4.7-.2-.4.9-1.4.9-1.4z"
      fill="#fff"
    />
    <path
      d="M121.718 120.928c-.4.2-14 10.4-14 10.4s21.2-6 21.4-6.4c.3-.4 1.6-1.5 1.1-1.9-.4-.5-7.9-2.4-8.5-2.1z"
      fill="#E6E5D7"
    />
    <path
      d="M109.618 128.228c-.2.2.4 2.8 1.6 3.5 1.8-.5 2.7-1.4 2.7-1.4s-3.5-2.6-4.3-2.1z"
      fill="#E3C7B0"
    />
    <path
      d="M112.218 126.328c-.6.1.3 3.3 1.8 4 1.3-.5 2.7-.9 2.7-.9s-3.5-3.2-4.5-3.1zm4.3-2.9c-.7.3-.2 4.2 1.7 5.5 1.6-.6 2.9-.9 2.9-.9s-3.6-5.1-4.6-4.6z"
      fill="#E3C7B0"
    />
    <path
      d="M53.518 167.828c.9 3.1 14.6 15.1 16.1 15.2 4 .3 16.1.5 17.4-.3 9.3-5.6 38.5-36 39.4-37 9.6-9.6 4.3-21.4 4.3-21.4l-43.8 13.2-8.5-2.8-23.6 4.8s-6 11.6-6.2 11.9c-.3 1.1 4.9 16.4 4.9 16.4z"
      fill="#F8AF97"
    />
    <path
      d="M85.418 71.828s7.1 17.5 7.8 20.7c.6 3.2 2.1 9.3-3.9 22.4-1.5 3.2-3 9.2-3 9.2l1 13.4s-34.7 16.7-38.4 13.9c-3.7-2.8.5-25.3.4-30.4-.1-5.2.1-47.4 3.2-48.6l11.1-4.3 17.2 2.3 4.6 1.4z"
      fill="#3C5749"
    />
    <path
      d="M86.218 137.528v-.3l-7.7-2.6-31.7 4.9s-.2 9.2 1.9 11.8c3.5 3.1 37.5-13.8 37.5-13.8z"
      fill="#253A2E"
    />
    <path
      d="M43.218 110.028s2.1 27.6 2.3 29c.2 1.4 7.1 3.2 8.5 3.2 1.4 0 7.1-13.2 7-14.9-.1-2.8-.2-24.6-1-25.3-.8-.6-17.6-.8-17.6-.8l.8 8.8z"
      fill="#ECD0B7"
    />
    <path
      d="M61.018 127.428s-7 2.5-9.9 4.6c-2.9 2.1-2.5 9-1.8 9.3 4.7 2 7.8 1.2 16.7.2 9.5-1.1 36.5-8.2 36.5-8.2l10.8-8.5s-4.1-1.7-6-1.4c-1.9.3-6 4.3-7.2 4.3-1.4-.1-39.1-.3-39.1-.3z"
      fill="#ECD0B7"
    />
    <path
      d="M42.618 77.328c-.9 3.5-3.5 35-3.5 35s22.2-1.1 22.1-.4c0 .3 1-22 .7-27.1-.3-5.1-.6-15.8-.6-15.8s-15.1 4.5-18.7 8.3z"
      fill="#3C5749"
    />
    <path
      d="M59.718 92.028s.1 5.5.3 11.2"
      stroke="#28362C"
      strokeWidth={0.467}
      strokeMiterlimit={10}
    />
    <path
      d="M71.118 144.928s1.2 8.8.2 10.3c-1.9 2.7-5.4 6.7-9.1 10.1"
      stroke="#F69271"
      strokeWidth={0.3}
      strokeMiterlimit={10}
    />
    <path
      d="M256.318 97.028c-2.9-2.4-82.5-3.5-85-.8s0 39.7 2.9 42.9c1.9 2.1 14.8.4 33.4 1.2 1.2 12.6 25.1 22.7 25.1 21.1 0-3.6-1.7-13 2.1-22.2 7.4-.3 15.6-.5 17.2-.9 10.1-2.4 7.2-38.9 4.3-41.3z"
      fill="#fff"
    />
    <path
      d="M151.318 174.328l11.9 28.9"
      stroke="#F69271"
      strokeWidth={0.3}
      strokeMiterlimit={10}
    />
    <path
      d="M32.418 267.228h217.7"
      stroke="#3C5749"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M57.718 31.628c.7-3.6 2.7-7.5 7.3-6.5 4 .8 5 1.8 9 .9 4.6-1 7.1-3.7 11.3-4.3 4.7-.7 9.3 1.9 8.9 5.4-.4 3.5-.5 7.3 1.4 9.8 1.9 2.5 6 6.9 6.5 10.4.4 3.3-2 6.1-5.5 8.2-3.5 2.1-4 1.4-5.6 3.6-2.1 2.7-.6 5.2-1.8 7-2 3.1-13.9 2-18.2-.2-2.1-1-8.5-1.6-11.4-6.9-3.3-6 1.8-9.2-.4-15.6-1.9-4.9-2.2-8.4-1.5-11.8z"
      fill="#28362C"
    />
    <path
      d="M75.918 62.128s-.3 7.3 1.6 13.4c-2.1.7-7.1 1.9-9.3 1.7-2.2-.2-6.5-4.5-6.5-4.5s4-12.4 3.1-18.9c9.8 6.4 11.1 8.3 11.1 8.3z"
      fill="#E3C7B0"
    />
    <path
      d="M64.218 47.828s-3.2-6-.8-7.2c2.4-1.2 2.7 1.2 4.6 1.3 1.9.1 5.8-5.8 6.7-5.3 1 .6 3.2 3.6 6.6 4.5 4.3 1.1 7 .4 7.4.5.4.1-1.5 13.8-3.5 17.8-1.4 2.7-5.1 6.8-8.1 5.9-8.1-2.4-11.5-8.7-12.5-10.9-1.2-2.1-.4-6.6-.4-6.6z"
      fill="#ECD0B7"
    />
    <path
      d="M82.318 48.528c-.1 1 0 3.1 0 3.6 0 2.3.8 4.3 2.4 4.9 1.4.5 2.6.1 4.2-1.2 1.7-1.5 3-5.1 2.8-5.7-.2-.6-1.6-1.1-4.2-1.5-1.5-.2-4-.1-4-.1s-1.6.1-2.8-.4c0 0-4.6-2.3-7.5-2.7-2.9-.4-3.7-.4-4.1.2-.4.6-.2 4.6 1.1 6.8 1.3 2.3 2.4 3.1 4.6 3.2 2.2.2 4.7-1.6 5.6-3.7.2-.5.8-2.1 1-3.6"
      stroke="#3C5749"
      strokeWidth={0.307}
      strokeMiterlimit={10}
    />
    <path
      d="M83.918 24.728s-7.1 5.7-15.9 4.3c-8.8-1.4-15.1 6.4-8 17.2m34.1-19s-4.4 5.3-2.3 9.5c2.1 4.2 8.9 9.5 8.2 14.3-.7 4.5-9.5 9.1-10.2 9.2"
      stroke="#3C5749"
      strokeWidth={0.25}
      strokeMiterlimit={10}
    />
    <path
      d="M178.818 208.828c-1.6-.8-3.8-1.9-4.2-1.1-.5.8-.6 3.9-.3 4.9.4 1 2.2-.9 3.1-1.7.8-.8 1.4-2.1 1.4-2.1zm32.5 3.2c.8 1.1 1.1 2.2.2 3.3-.6.6-8.1 4.9-14.1 7.6-6 2.7-23.2 10.6-25 11.4-2.2.9-4.6 1.9-5.5 1.4-1.4-.8-2.1-6.6-2.1-6.6s13.7-4.5 21.4-7.8c7.7-3.2 18.5-7.1 20.9-8.5 2.4-1.4 2.8-1.9 2.8-1.9s.7.1 1.4 1.1z"
      fill="#E6E5D7"
    />
    <path
      d="M209.818 210.828s-1.1-1.7-2.8-1.5c-1.7.2-9.8 1.1-18.6.1-4.2-.5-8.9-1-10.2-1.2-1.3-.1-3.5 4.5-3.7 5.1-.2.6-2.2 2.2-3.7 2.9-1.5.7-2.2.8-3.2.4s-1.7-3.3-3.1-2.7c-1.4.6-2.4 1.6-2.5 2.2-.1.6.6 5.3 1.2 7.1.6 1.8 1.6 5.5 1.6 5.7.1.2 5.1-.7 14.4-4.5 8.4-3.4 23.2-9.4 25.7-10.6 3.6-1.6 4.9-3 4.9-3z"
      fill="#fff"
    />
    <path
      d="M182.018 208.229s.4 1.3-.4 2.5m3.7-2.301s.6 1.8 0 2.8m3.2-2.499s.7 1.6.4 3.1m3-2.701s.7 1.6.4 3.1m3-2.3s.6.8.3 2.2"
      stroke="#E6E5D7"
      strokeWidth={0.614}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M133.918 249.128c-1.1-1.4-2.7-3.3-3.4-2.7-.8.6-2.2 3.3-2.3 4.4-.1 1.1 2.4.1 3.5-.4s2.2-1.3 2.2-1.3zm28.4 16.1c.2 1.3.1 2.5-1.2 3.1-.8.3-9.4 1.2-16 1.2s-25.5.3-27.5.2c-2.4-.1-5-.2-5.6-.9-1-1.3.8-6.9.8-6.9s14.4 1.4 22.7 1.6c8.3.2 19.8 1 22.6.7 2.7-.4 3.3-.6 3.3-.6s.6.4.9 1.6z"
      fill="#E6E5D7"
    />
    <path
      d="M161.418 263.528s-.3-2-2-2.5c-1.6-.5-9.4-3-17-7.4-3.7-2.1-7.7-4.5-8.8-5.2-1.1-.6-5 2.7-5.5 3.1-.5.4-2.9 1.1-4.6 1.1-1.6 0-2.3-.2-3.1-1-.8-.8-.2-3.7-1.8-3.7-1.5 0-2.8.5-3.2 1-.4.5-1.6 5.1-1.8 6.9-.2 1.8-.8 5.7-.8 5.9 0 .2 4.9 1.4 15 1.7 9 .3 25 .9 27.8.8 4 0 5.8-.7 5.8-.7z"
      fill="#fff"
    />
    <path
      d="M137.018 249.828s-.2 1.3-1.4 2.2m4.4-.7s-.2 1.9-1.1 2.6m3.9-1s0 1.8-.9 3m3.8-1.2s0 1.8-.9 3m3.7-.9s.2 1-.6 2.2"
      stroke="#E6E5D7"
      strokeWidth={0.614}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.518 78.528s2.9 7.2 4.6 14c2.4 9.4.2 12.9-1 15.4"
      stroke="#28362C"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M121.518 139.228c-.3 1.5.7 4.7 2.6 9 1.4-1.4 2.2-2.3 2.4-2.5 9.6-9.6 4.3-21.4 4.3-21.4-.6.3-7.7 6.5-9.3 14.9z"
      fill="#F79E81"
    />
    <path
      d="M89.118 166.328s35.2-26.9 36.2-27.9 10 .3 10 .3l7 16.3"
      stroke="#F69271"
      strokeWidth={0.3}
      strokeMiterlimit={10}
    />
    <path
      d="M68.218 77.228c2.2.2 7.2-1.1 9.3-1.7-.6-1.9-1-3.8-1.2-5.7l-12.8-1.7s-.2.1-.6.1c-.6 2.6-1.2 4.4-1.2 4.4s4.3 4.4 6.5 4.6z"
      fill="#DABCA6"
    />
    <path
      d="M147.518 185.128c.2-.7.3-1.2.5-1.5 1.9-5.9 4.7-16.1 4.7-17.1 0-.9-6.3-9.8-7.5-10.6-2.2-1.6-23.3 25.8-23 27v1.3l25.3.9z"
      fill="#F69575"
    />
    <path
      d="M60.718 111.828c-.1-5-.4-9.4-.7-9.7-.8-.6-17.6-.8-17.6-.8l.8 8.7s0 .6.1 1.7c4.5-.1 15-.3 17.4.1z"
      fill="#2B3F33"
    />
    <path
      d="M276.018 6.328c-2.1-2.2-118.2-5.8-121.5-1.2-.7 1-1.4 3.3-1.9 6.3s-.9 6.8-1 10.6c-.1 2.5-.1 5 0 7.4.3 7 1.5 13.4 4 15.6 1.6 1.4 39.2 1.7 71.5 1.2 3.5 10.2 23.8 19.8 26.3 19 2.4-.8-.2-11.6 3.3-19.8 8.5-.3 14.6-.7 16.1-1.2 7.5-2.1 5.3-35.7 3.2-37.9z"
      fill="#fff"
    />
    <path
      d="M280.318 4.428c-2.1-2.2-118.2-5.8-121.5-1.2-.7 1-1.4 3.3-1.9 6.3s-.9 6.8-1 10.6c-.1 2.5-.1 5 0 7.4.3 7 1.5 13.4 4 15.6 1.6 1.4 39.2 1.7 71.5 1.2 3.5 10.2 23.8 19.8 26.3 19 2.4-.8-.2-11.6 3.3-19.8 8.5-.3 14.6-.7 16.1-1.2 7.5-2.1 5.3-35.7 3.2-37.9zm-117.1 12.5h79.8m-79.8 10.3h99.1m-3.3 69.9c-2.9-2.4-82.5-3.5-85-.8s0 39.7 2.9 42.9c1.9 2.1 14.8.4 33.4 1.2 1.2 12.6 25.1 22.7 25.1 21.1 0-3.6-1.7-13 2.1-22.2 7.4-.3 15.6-.5 17.2-.9 10.1-2.3 7.2-38.9 4.3-41.3z"
      stroke="#C7C6B7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M202.318 116.028c.2 0 8.1-2.2 9.5-3.5 1.4-1.3 4.9-4.3 5.4-7.7.5-3.9.2-4.9 2.1-5.3 1.6-.3 3.1.2 4 2.2.6 1.5.5 4.8-1.5 8.7-1 1.9-1 3-.5 3.4.5.4 6.7 1 6.9 5 .1 4-1.5 13.6-3.8 14.5-2.3.8-11.5.7-14-.5s-3.9-3-5.1-3.8c-1.4-1-2.4-1.5-2.7-1.9-.6-.8-.3-11.1-.3-11.1z"
      fill="#F5E202"
    />
    <path
      d="M224.418 113.628c-.3 0-4.4-.1-5.5 1.7-1.1 1.8-.3 4 1.8 4.2 1.3.1 5.3-.5 6.3-.7 1-.1 3.3-.4 3.6-2 .3-1.7-.4-3.1-1.7-3.3-1.4-.2-4.5.1-4.5.1z"
      fill="#FAF258"
    />
    <path
      d="M219.618 120.028c-1 .8-1.3 2.9.1 3.7.7.4 2.8.5 4.4.6 1.6.1 5.2-.1 6.3-.5 1.5-.6 1.8-2.3 1.4-3.3-.4-1-.7-1.8-3.4-1.7-2.8.1-7.7.4-8.8 1.2z"
      fill="#FAF258"
    />
    <path
      d="M218.618 125.928c-.6.9-.4 2.2.9 2.8 1.3.6 4 .4 5.8.5 1.9.1 4.5.1 5.1-.8.6-.9.7-2.2.2-2.8-.4-.7-1.8-1.3-4.8-1.3-2.9 0-5.7-.7-7.2 1.6z"
      fill="#FAF258"
    />
    <path
      d="M218.518 130.428c-.5 1-.5 1.6.2 2.4.8.8 1.7 1 3.3 1.1 1.6.1 4.3 0 5.5-.6 1-.5 1.5-1.3 1-2.3-.5-1-2.3-2-5.2-1.9-3 .1-4.3.3-4.8 1.3z"
      fill="#FAF258"
    />
    <path
      d="M220.018 119.628l-.1-.4 8.5-.5v.3l-8.4.6zm.8 4.8v-.3h7.1v.3h-7.1zm5.8 5.1l.1-.3-6.4-.2-.2.4 6.5.1z"
      fill="#F5E202"
    />
    <path
      d="M193.518 36.728c-2.9-2.8-81.4-1.5-81.4-1.5-4.8 6.7-4.3 41.9-1.4 45.7.5.7 6.2 1.2 15.1 1.6 1.7 9.1-1 16.1-.7 21.3 5.2.5 20.4-11.4 26.9-20.8 27.7-.4 30.4.5 37-1.4 10.1-2.8 7.4-42.1 4.5-44.9z"
      stroke="#4E6659"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M138.318 59.928c.5-.4 2.3-1 3.4.4s2.7 4.1 3.5 4.7c.8.6 1.9 1 2.8.9.9-.1 2.7-.5 3.2-1.1.6-.7.9-2.5 1-3.3.1-.8-.1-2.2-.9-2.8-.8-.6-3.1-1.6-4.5-1.3-.8.2-3.2 1.2-3.6 1.4-.4.2-2.2.7-3.3-.1-1.2-.8-1.6-2.2-1.2-3 .5-1 3.1-2.3 4.1-2.9 1.1-.6 2.3-1.2 3.6-1.2.9 0 2.6.4 2.9.1.3-.3-.7-1.9-1.4-2.5-.7-.6-2.3-2.5-1.9-3.5.4-1 1-1.5 1.4-1.6 1.3-.2 2.3 1.5 2.6 1.1.4-.5-.7-1.7-.3-3.2.4-1.1 1.7-1.6 2.9-1.2.8.3 3.1 2.6 4.1 4.2.7 1.1 3.9 7 4.4 9 .3 1.4.6 8.2.6 8.2s-1.5 5.4-2.1 6.9c-.7 1.5-2.6 4.3-4 4.8s-12.1-.7-12.1-.7-3.5-3.9-4.3-5.5c-.9-1.6-1.7-4.8-2-5.2-.3-.4 1.1-2.6 1.1-2.6z"
      fill="#F5E202"
    />
    <path
      d="M149.318 51.728s6.7.3 9.3 5.5m-8.5-12s3.1 2.4 4.3 7.8"
      stroke="#FCF79B"
      strokeWidth={0.405}
      strokeMiterlimit={10}
    />
  </Svg>
)

export default Support
